import { SiteInformation } from "@ta-interaktiv/types/lib/admin.publishing.tamedia.ch/admin-api/v1/SiteInformation";

export const tenantSiteInfos: SiteInformation[] = [
    {
        key: "derbund",
        name: "der Bund",
        domain: "derbund",
        feedId: 1,
        lang: "de",
        fbAppId: "160395880675799",
        twitterHandle: "@derbund"
    },
    {
        key: "tagesanzeiger",
        name: "Tages-Anzeiger",
        domain: "tagesanzeiger",
        feedId: 2,
        lang: "de",
        fbAppId: "147124108642216",
        twitterHandle: "@tagesanzeiger"
    },
    {
        key: "bernerzeitung",
        name: "Berner Zeitung",
        domain: "bernerzeitung",
        feedId: 3,
        lang: "de",
        fbAppId: "151632851557044",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "bazonline",
        name: "Basler Zeitung",
        domain: "bazonline",
        feedId: 5,
        lang: "de",
        fbAppId: "185771024788811",
        twitterHandle: "@bazonline"
    },
    {
        key: "berneroberlaender",
        name: "Berner Oberländer",
        domain: "berneroberlaender",
        feedId: 8,
        lang: "de",
        fbAppId: "209848109731135",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "thunertagblatt",
        name: "Thuner Tagblatt",
        domain: "thunertagblatt",
        feedId: 9,
        lang: "de",
        fbAppId: "428779510948903",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "langenthalertagblatt",
        name: "Langenthaler Tagblatt",
        domain: "langenthalertagblatt",
        feedId: 10,
        lang: "de",
        fbAppId: "2223961417826140",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "zsz",
        name: "Zürichsee-Zeitung",
        domain: "zsz",
        feedId: 11,
        lang: "de",
        fbAppId: "1538332599783320",
        twitterHandle: "@ZSZonline"
    },
    {
        key: "landbote",
        name: "Der Landbote",
        domain: "landbote",
        feedId: 12,
        lang: "de",
        fbAppId: "738531732909881",
        twitterHandle: "@landbote"
    },
    {
        key: "zuonline",
        name: "Zürcher Unterländer",
        domain: "zuonline",
        feedId: 13,
        lang: "de",
        fbAppId: "900877159943131",
        twitterHandle: "@ZUnterland"
    },
    {
        key: "tdg",
        name: "Tribune de Genève",
        domain: "tdg",
        feedId: 14,
        lang: "fr",
        fbAppId: "222318267841285",
        twitterHandle: "@tdgch"
    },
    {
        key: "24heures",
        name: "24 heures",
        domain: "24heures",
        feedId: 15,
        lang: "fr",
        fbAppId: "251285271592561",
        twitterHandle: "@24heuresch"
    },
    {
        key: "bilan",
        name: "Bilan",
        domain: "bilan",
        feedId: 17,
        lang: "fr",
        fbAppId: "389372458174754",
        twitterHandle: "@bilanmagazine"
    }
]